// extracted by css-extract-rspack-plugin
var _1 = "src-components-Base-DefaultAvatar-DefaultAvatar-module__defaultAvatar-zz8Rx_";
var _2 = "src-components-Base-DefaultAvatar-DefaultAvatar-module__fill-dHaW1z";
var _3 = "src-components-Base-DefaultAvatar-DefaultAvatar-module__large-bXj8b8";
var _4 = "src-components-Base-DefaultAvatar-DefaultAvatar-module__medium-ple5lZ";
var _5 = "src-components-Base-DefaultAvatar-DefaultAvatar-module__small-oXXNf1";
var _6 = "src-components-Base-DefaultAvatar-DefaultAvatar-module__square-OYyRHb";
export { _1 as "defaultAvatar", _2 as "fill", _3 as "large", _4 as "medium", _5 as "small", _6 as "square" }

    if(module.hot) {
      (function() {
        var localsJsonString = "{\"defaultAvatar\":\"src-components-Base-DefaultAvatar-DefaultAvatar-module__defaultAvatar-zz8Rx_\",\"fill\":\"src-components-Base-DefaultAvatar-DefaultAvatar-module__fill-dHaW1z\",\"large\":\"src-components-Base-DefaultAvatar-DefaultAvatar-module__large-bXj8b8\",\"medium\":\"src-components-Base-DefaultAvatar-DefaultAvatar-module__medium-ple5lZ\",\"small\":\"src-components-Base-DefaultAvatar-DefaultAvatar-module__small-oXXNf1\",\"square\":\"src-components-Base-DefaultAvatar-DefaultAvatar-module__square-OYyRHb\"}";
        // 1752373455094
        var cssReload = require("../../../../node_modules/.pnpm/@rspack+core@1.4.6_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  